import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconDown.css';

const UP = 'up';
const DOWN = 'down';
const LEFT = 'left';
const RIGHT = 'right';

const IconDown = props => {
  const { rootClassName, className, direction } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z">

        </path>
    </svg>
  )
};

IconDown.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconDown.propTypes = {
  rootClassName: string,
  className: string,
  direction: string.isRequired,
};

export default IconDown;
